export default "__VITE_ASSET__CWy2gup2__"